import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import { store } from './store/storeConfig'
import { Provider } from 'react-redux';
import ScrollToTop from './hooks/scrollToTop';

import './styles/abstracts/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {injectStore} from "./ApiService";
injectStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
